import React from 'react';
import styled from 'styled-components';
import { buttonTokens } from '../../tokens/components/Button/tokens';
import { SiteKitProvider, useSiteKit } from './components/SiteKitContext/SiteKitContext';
import { SiteKitLayout } from './components/SiteKitLayout/SiteKitLayout';

// Subcomponents
import { SiteKitContent } from './components/Content/SiteKitContent/SiteKitContent';
import { SiteKitHeader } from './components/Content/SiteKitHeader/SiteKitHeader';
import { SiteKitIcon } from './components/SiteKitIcon/SiteKitIcon';
import { SiteKitIconButton } from './components/SiteKitIcon/SiteKitIconButton/SiteKitIconButton';
import { SiteKitIconAnchor } from './components/SiteKitIcon/SiteKitIconAnchor/SiteKitIconAnchor';
import { SiteKitLocalNav } from './components/Content/SiteKitLocalNav/SiteKitLocalNav';
import { SiteKitLogoAnchor } from './components/Sidebar/SiteKitLogoAnchor/SiteKitLogoAnchor';
import { SiteKitSidebar } from './components/Sidebar/SiteKitSidebar/SiteKitSidebar';

// Fragments
const SiteKitSkipToMainWrapper = styled.a`
  left: -100%;
  position: absolute;
  top: 16px;
  padding: 12px;
  background: white;
  text-align: center;
  z-index: 1;

  &:focus {
    box-shadow: ${buttonTokens.ShadowSecondaryKeyboardFocus};
  }

  &:focus:not(:focus-visible) {
    box-shadow: none;
  }

  &:focus-visible {
    box-shadow: none;
    outline: ${buttonTokens.OutlineStrokeSecondaryKeyboardFocus} ${buttonTokens.OutlineColorSecondaryKeyboardFocus};
    outline-offset: ${buttonTokens.OutlineOffsetSecondaryDefault};
  }

  &:focus,
  &:active {
    left: 8px;
  }
`;

// Exports
interface SiteKitProps {
  children: React.ReactNode;
}
const SiteKit = ({ children }: SiteKitProps) => (
  <SiteKitProvider>
    <SiteKitSkipToMainWrapper href="#main">Skip to main</SiteKitSkipToMainWrapper>
    <SiteKitLayout>{children}</SiteKitLayout>
  </SiteKitProvider>
);
SiteKit.Content = SiteKitContent;
SiteKit.Header = SiteKitHeader;
SiteKit.Icon = SiteKitIcon;
SiteKit.IconButton = SiteKitIconButton;
SiteKit.IconAnchor = SiteKitIconAnchor;
SiteKit.LocalNav = SiteKitLocalNav;
SiteKit.LogoButton = SiteKitLogoAnchor;
SiteKit.Sidebar = SiteKitSidebar;
SiteKit.useSiteKit = useSiteKit;

export { SiteKitProps };

SiteKit.displayName = 'SiteKit';

export default SiteKit;
